import type { PolicyKind } from '@nucleus-commerce/api-client/admin';

/** Footer order on the storefront; custom documents follow, by title. */
export const FIXED_POLICY_KINDS: ReadonlyArray<Exclude<PolicyKind, 'custom'>> = [
  'terms',
  'privacy',
  'shipping',
  'returns',
  'warranty',
  'resizing',
  'auction',
];

export const POLICY_LIMIT = 50;

/** The storefront path of a policy; the backend writes its redirects between these. */
export function policyPath(handle: string): string {
  return `/policies/${handle}`;
}

/** The backend defaults the handle to the kind; a custom policy has to bring its own. */
export function defaultPolicyHandle(kind: PolicyKind): string {
  return kind === 'custom' ? '' : kind;
}
